import React from "react";
import CardHeader from "./CardHeader/cardHeader";
import CardUser from "./CardUser/cardUser";

function EditUserScreen(props) {
    return (
        <>
            <CardHeader />
            <CardUser />
        </>
    )
}

export default EditUserScreen
